import React from "react";
import img from "../../../../components/produits/groupe_pages/SL/img/webp/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp";


const Block = ({ title, children }) => (
  <section className="pj-block">
    <h2>{title}</h2>
    <div className="pj-block-content">{children}</div>
  </section>
);

export default function ProjectRabatAgdal() {
  return (
    <div className="pj-page">

      {/* HERO */}
      <section className="pj-hero">
        <div className="pj-hero-text">
          <span className="pj-badge">PROJET RÉFÉRENCE</span>
          <h1>Gare Rabat Agdal <br/> Solutions lumineuses</h1>

          <p>
            Réalisation d’une conception lumineuse innovante alliant esthétique
            architecturale et confort visuel.
          </p>

          <p className="pj-sub">
            Solutions UNIK SYSTEM : Éclairage architectural, mise en lumière
            des façades, solutions LED intérieures.
          </p>

          <div className="pj-hero-actions">
            
            <a className="btn-primarya" href="/devis">Demander un devis</a>
            <a href="/docs/catalogue-unik-system.pdf"download className="btn-outline">Télécharger la fiche projet</a>
            
          </div>
        </div>

        <div className="pj-hero-img">
          <img
            src={img}
            alt="Gare Rabat Agdal"
          />
        </div>
      </section>

      {/* CONTEXTE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Contexte du projet</span>}>
        <p>
          Mise en valeur d’une infrastructure majeure à travers une stratégie
          d’éclairage architectural combinant design, performance et lisibilité
          nocturne.
        </p>
        <p>
          Le travail a porté sur les façades, les zones d’accueil et les
          espaces de circulation avec une approche lumière intégrée à
          l’architecture.
        </p>
      </Block>

      {/* SOLUTIONS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Solutions UNIK SYSTEM</span>}>
        <ul className="pj-list">
          <li>Éclairage architectural intégré</li>
          <li>Mise en lumière de façade</li>
          <li>Lignes LED structurelles</li>
          <li>Plafonds lumineux techniques</li>
          <li>Solutions LED intérieures</li>
          <li>Diffusion lumineuse homogène</li>
        </ul>
      </Block>

      

      {/* RESULTATS */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Résultats obtenus</span>}>
        <ul className="pj-list">
          <li>Signature visuelle forte</li>
          <li>Architecture valorisée</li>
          <li>Ambiance nocturne premium</li>
          <li>Lecture claire des volumes</li>
          <li>Expérience usager améliorée</li>
        </ul>
      </Block>

      {/* GALERIE */}
      <Block title={<span style={{ color: "#EE2D2B" }}>Galerie projet</span>}>
        <div className="pj-gallery">
          <img src={img} alt="" />
          <img src={img} alt="" />
          <img src={img} alt="" />  
        </div>
      </Block>

      {/* CTA */}
      <section className="pj-cta">
        <h2>Vous avez un projet similaire ?</h2>
        <p>Notre équipe technique vous accompagne de la conception à la pose.</p><br/>
                <a href="/contact" className="btn-primarya">Contact nos</a>
      </section>

    </div>
  );
}